import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'

const resource = 'templates'
const verb = 'get'

export default class OspreyTemplatesSearch extends BaseAction {
    constructor(dataKey) {
        const id = '8ac10111-65c0-4767-93e5-5cab5eb2599d'
        const path = `/${resource}`
        super(resource, verb, path, id, dataKey)
        this.noCache = true
    }

    search(params) {
        this.params = Object.assign({
            fields: 'archived,created,channels,expiration,id,marketingCategory,modified,name,ownerOrn,programTypes,shareTo,status,tags,thumbnailUrl,approvalRequired',
            archived: false,
            channel: '1,3,4'
        }, params)

        // Added requestFrom:'sod' key value pair that tell the API request origin
        let origin = (window.location.pathname)
        if(origin=='/messaging/mg/newMessage')
            this.params['requestFrom'] = 'sod'

        return fetchContentIfNeeded(this)
    }
}



// WEBPACK FOOTER //
// src/actions/osprey-api/templates/templates-search.js